import React from "react";
import logo from "../images/Leap Forward Logo.png";
import facebookIcon from "../icons/facebook-icon.png";
import mailIcon from "../icons/mail-icon.png";

const LeftSideBar = () => {
  const handleButtonClick = (e) => {
    e.stopPropagation();
  };
  return (
    <div className="left-sidebar">
      <div className="logo-container">
        <img src={logo} alt="Leap Forward" className="leap-forward-logo" />
      </div>
      <div className="sidebar-text-container">
        <span className="sidebar-text">
          THE WEB-SENSE: <span>Interactive Map of Being</span>
        </span>
      </div>
      <div className="sidebar-footer-icons">
        <a
          href="https://www.facebook.com/LeapForwardCommunity/"
          rel="noreferrer"
          target="_blank"
        >
          {/*  eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
          <img
            src={facebookIcon}
            alt=""
            className="facebook-icon"
            onClick={handleButtonClick}
          />
        </a>
        <a href="mailto:info@leapforward.us">
          {/*  eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
          <img
            src={mailIcon}
            alt=""
            className="mail-icon"
            onClick={handleButtonClick}
          />
        </a>
      </div>
    </div>
  );
};

export default LeftSideBar;
